module.exports = __webpack_public_path__ + "quilt1-level2.872f81cc.png";